@if (hasScore) {
  <div class="ui-score-level__level ui-script"> {{ scoreLevel.level }}</div>
  @if (scoreLevel.status === ResultStatusEnum.STATUS_INCOMPLETE) {
    <div
      class="ui-score-level__wip"
      data-cy="result-score-level-incomplete"
      >
      <campus-icon class="ui-score-level__wip-icon" svgIcon="hourglass"></campus-icon>
    </div>
  }
} @else {
  <campus-icon
    class="ui-score-level__no-result-icon"
    svgIcon="no-result"
    data-cy="ui-score-level-no-result"
  ></campus-icon>
}

